import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum GameStateEnum {
  MAIN_MENU = 'MAIN_MENU',
  WAVE_IN_PROGRESS = 'WAVE_IN_PROGRESS',
  WAVE_COMPLETED = 'WAVE_COMPLETED',
  PAUSED = 'PAUSED',
  GAME_OVER = 'GAME_OVER',
  VICTORY = 'VICTORY'
}

interface GameState {
  currentState: GameStateEnum;
  previousState: GameStateEnum;
  showUpgradeMenu: boolean;
}

const initialState: GameState = {
  currentState: GameStateEnum.MAIN_MENU,
  previousState: GameStateEnum.MAIN_MENU,
  showUpgradeMenu: false
};

const gameStateSlice = createSlice({
  name: 'gameState',
  initialState,
  reducers: {
    /**
     * Sets the game state
     */
    setGameState: (state, action: PayloadAction<GameStateEnum>) => {
      state.previousState = state.currentState;
      state.currentState = action.payload;
      
      // Automatically show upgrade menu when wave is completed
      state.showUpgradeMenu = action.payload === GameStateEnum.WAVE_COMPLETED;
    },
    
    /**
     * Sets whether to show the upgrade menu
     */
    setShowUpgradeMenu: (state, action: PayloadAction<boolean>) => {
      state.showUpgradeMenu = action.payload;
    }
  }
});

export const { setGameState, setShowUpgradeMenu } = gameStateSlice.actions;
export default gameStateSlice.reducer; 